import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    // Fire Meta Pixel AddToCart event
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart');
    }
    window.open('https://guiastoolkit.com/cart/45983325814972:1', '_blank');
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 4px 14px 0px rgba(255,183,3,0.3)', '0px 4px 24px 0px rgba(255,183,3,0.5)', '0px 4px 14px 0px rgba(255,183,3,0.3)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`w-full md:w-auto bg-gradient-to-b from-amber to-amber-hover text-[#0B1A14] font-bold text-xl py-4 px-8 md:px-10 rounded-lg shadow-lg transition-colors ${className}`} data-id="element-153">
      {children}
    </motion.button>;
}